





    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "productHaji",
        components: {},
        mixins:[]
    })
    export default class productHaji extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
